<template>
  <div class="navbar">
    <hamburger :toggle-click="toggleSideBar" :is-active="sidebar.opened" class="hamburger-container" />

    <breadcrumb class="breadcrumb-container" />

    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <error-log class="errLog-container right-menu-item" />

        <el-tooltip :content="$t('navbar.screenfull')" effect="dark" placement="bottom">
          <screenfull class="screenfull right-menu-item" />
        </el-tooltip>

        <el-tooltip :content="$t('navbar.size')" effect="dark" placement="bottom">
          <size-select class="international right-menu-item" />
        </el-tooltip>

        <el-tooltip v-if="multilingual" :content="$t('navbar.language')" effect="dark" placement="bottom">
          <lang-select class="international right-menu-item" />
        </el-tooltip>
      </template>

      <domain-select class="domain-select right-menu-item" />

      <el-dropdown class="avatar-container right-menu-item" trigger="click">
        <div class="avatar-wrapper">
          <img v-if="avatar" :src="avatar" class="user-avatar" alt="" />
          <img v-if="!avatar" src="@/assets/default-avatar.png" class="user-avatar" alt="" />
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/user/settings">
            <el-dropdown-item>
              <i class="el-icon-setting" />
              {{ $t('route.userSettings') }}
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span style="display:block;" @click="logout">
              <i class="el-icon-d-arrow-right" />
              {{ $t('navbar.logOut') }}
            </span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import DomainSelect from '@/components/DomainSelect';
import ErrorLog from '@/components/ErrorLog';
import Hamburger from '@/components/Hamburger';
import LangSelect from '@/components/LangSelect';
import Screenfull from '@/components/Screenfull';
import SizeSelect from '@/components/SizeSelect';

export default {
  components: {
    Breadcrumb,
    DomainSelect,
    ErrorLog,
    Hamburger,
    LangSelect,
    Screenfull,
    SizeSelect
  },
  computed: {
    ...mapGetters(['sidebar', 'name', 'avatar', 'device', 'multilingual', 'disableDomainChange'])
  },
  methods: {
    logout() {
      this.$store.dispatch('logOut').then(() => {
        window.location.href = '/';
      });
    },
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar');
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;

  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }

    .screenfull {
      height: 20px;
    }

    .domain-select {
      vertical-align: top;
    }

    .international {
      vertical-align: top;
    }

    .avatar-container {
      height: 50px;
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
